import {actionTypes} from "redux-router5";
import Utils from "platform/util/Utils";
import {Logger} from "platform/logger/Logger";
import {Action, Dispatch, Middleware, MiddlewareAPI} from "redux";
import Script from "platform/network/script/Script";
import {DPK} from "platform/dpk/Dpk";
import Platform from "platform/Platform";
import {ExecuteDpk} from "platform/redux/dpk/DpkActions";

interface IdentifyProps {

    userId: number;
    username: string;
}

// documentation: https://docs.appcues.com/article/161-javascript-api
export class AppCues {

    private static _instance: AppCues;
    private readonly _logger: Logger = Logger.Of("AppCues");
    private _appCues: any;
    private _middleware: Middleware;
    private _identifyProps: IdentifyProps;
    private _identified: boolean;

    public static instance(): AppCues {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
    }

    public load = () => {
        this._logger.debug("Inject script");
        Script.injectScript("https://fast.appcues.com/40754.js", "appCues", () => {
            this._appCues = (window as any).Appcues;
            if (Utils.isNotNull(this._appCues)) {
                this._logger.debug("Ready");
                this._appCues.on("all", (event: string, payload: any) => {
                    if (event === "step_interacted" && payload?.flowName?.indexOf(DPK) === 0) {
                        Platform.dispatch(ExecuteDpk({dpk: payload?.flowName}));
                    }
                });
                this._appCues.on("flow_started", (payload: any) => {
                    const flowName: string = payload.flowName;
                    if (flowName.indexOf("[F]") !== -1) {
                        this.freezeUI();
                    }
                });
                this._appCues.on("flow_completed", (payload) => {
                    this.unfreezeUI();
                });
                this._appCues.on("flow_skipped", (payload) => {
                    this.unfreezeUI();
                });
                this._appCues.on("step_child_error", () => {
                    this.unfreezeUI();
                });
                this.Identify(this._identifyProps);
            } else {
                this._logger.debug("Failed");
            }
        });
    }

    private cleanFlowName(flowName: string): string {
        let r: string = flowName;
        r = r.replace("[F]", "");
        return r;
    }

    private freezeUI(): void {
        if (document.getElementById("RootElement")) {
            document.getElementById("RootElement").classList.add("appcues-freeze-ui");
        }
    }

    private unfreezeUI(): void {
        if (document.getElementById("RootElement")) {
            document.getElementById("RootElement").classList.remove("appcues-freeze-ui");
        }
    }

    public Identify = (props: IdentifyProps) => {
        this._identifyProps = props;
        if (this._appCues && !this._identified && props) {
            this._logger.debug("Identify: " + props.username);
            this._identified = true;
            this._appCues.identify(props.userId, {
                name: props.username
            });
        }
    }

    public Show = (id: string) => {
        if (this._appCues) {
            this._logger.debug("Show flow: " + id);
            this._appCues.show(id);
        }
    }

    public middleware<State>(): Middleware {
        if (Utils.isNull(this._middleware)) {
            this._middleware = (api: MiddlewareAPI<any>) => (next: Dispatch<Action>) => <A extends Action>(action: A): A => {
                if (action.type === actionTypes.TRANSITION_SUCCESS && Utils.isNotNull(this._appCues)) {
                    this._appCues.page();
                }
                return next(action);
            };
        }
        return this._middleware;
    }
}
